var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    id: "Backwards",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbf66",
    d: "M23,40a83.45,83.45,0,0,1-11.87-.85,5.08,5.08,0,0,1-4.28-4.28,83.35,83.35,0,0,1,0-23.73,5.08,5.08,0,0,1,4.28-4.28,83.35,83.35,0,0,1,23.73,0,5.08,5.08,0,0,1,4.28,4.28,83.34,83.34,0,0,1,0,23.73,5.08,5.08,0,0,1-4.28,4.28A83.45,83.45,0,0,1,23,40ZM23,8a81.38,81.38,0,0,0-11.58.83h0a3,3,0,0,0-2.59,2.59,81.29,81.29,0,0,0,0,23.16,3,3,0,0,0,2.59,2.59,81.28,81.28,0,0,0,23.16,0,3,3,0,0,0,2.59-2.59,81.28,81.28,0,0,0,0-23.16,3,3,0,0,0-2.59-2.59A81.38,81.38,0,0,0,23,8Z",
    className: "colorfbb03b svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f4a8a",
    d: "M20.5,24.54l8.26,6.82A2,2,0,0,0,32,29.82V16.18a2,2,0,0,0-3.27-1.54L20.5,21.46A2,2,0,0,0,20.5,24.54Z",
    className: "colorf15a24 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbf66",
    d: "M14.69,24.54l8.26,6.82a2,2,0,0,0,3.27-1.54V16.18a2,2,0,0,0-3.27-1.54l-8.26,6.82A2,2,0,0,0,14.69,24.54Z",
    className: "colorfbb03b svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwards);
export default __webpack_public_path__ + "static/media/backwards.d5499483c6ffef9dfa4736f9a70cceb3.svg";
export { ForwardRef as ReactComponent };